





























import Vue from 'vue'
import * as types from '@/store/modules/play/types'
import SoundOnScore from '@/components/play/SoundOnScore.vue'
import TrackBorder from '@/components/play/TrackBorder.vue'

export default Vue.extend({
  name: 'Track',

  props: {
    trackIndex: {
      type: Number,
      required: true,
    },
    trackHeight: {
      type: Number,
      required: true,
    },
  },

  components: {
    'sound-on-score': SoundOnScore,
    'track-border': TrackBorder,
  },

  computed: {
    /**
     * 選択中のトラック
     */
    selectedTrackIndex (): types.TrackIndex {
      return this.$store.state[types.moduleName].selectedTrackIndex
    },

    /**
     * トラックに配置されている音を取得
     */
    sounds (): types.SoundOnScore[] {
      return this.$store.state[types.moduleName].score.filter((sound: types.SoundOnScore) => {
        return sound.trackIndex === this.trackIndex
      })
    },

    /**
     * 選択中か
     */
    isSelected (): boolean {
      return this.selectedTrackIndex === this.trackIndex
    },

    /**
     * 再生モード
     */
    playMode (): types.PlayMode {
      return this.$store.state[types.moduleName].playMode
    },

    /**
     * 再生中 or 収録中
     */
    isPlaying (): boolean {
      return this.$store.state[types.moduleName].isPlaying
    },

    /**
     * 再生モードで再生中
     */
    isPlayingByPlayMode (): boolean {
      return this.isPlaying && this.playMode === 'play'
    },

    /**
     * 収録中（かつ選択中）
     */
    isRecording (): boolean {
      return this.isPlaying && this.playMode === 'record' && this.isSelected
    },

    /**
     * 幅
     */
    width (): number {
      return Math.round(this.$store.state[types.moduleName].duration * this.$store.state[types.moduleName].trackWidthPerSecond * 10) / 10
    },
  },

  methods: {
    /**
     * このトラックを選択する
     */
    active () {
      this.$store.commit(`${types.moduleName}/${types.Mutation.CHANGE_ACTIVE_TRACK}`, this.trackIndex)
    },
  },
})
